<template>
    <div class="way-home-main">
      <div class="home-fixed-back1" v-show="fxiedFlag"></div>
      <div class="home-fixed-back2" v-show="!fxiedFlag"></div>
      <div class="row way-home-banner">
        <div class="col-xl-12 col-12">
          <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
            <ol class="carousel-indicators">
              <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
              <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
            </ol>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img class="big" src="https://static.cleanlive.cn/site/img/home-big-banner.png" alt="">
                <img class="small" src="https://static.cleanlive.cn/site/img/home-banner.png" alt="">
              </div>
              <div class="carousel-item">
                <a href="https://m.waypal.com/apply/banner" target="_black">
                  <img class="big" src="https://static.cleanlive.cn/site/img/home-banner-2.png" alt="">
                  <img class="small" src="https://static.cleanlive.cn/site/img/home-ph-banner-2.png" alt="">
                </a>
              </div>
            </div>
          </div>
          <div class="login">
            <p class="tit">
              免费领取价值<span>300元</span>试听课
            </p>
            <input type="text" v-model="auditions.name" placeholder="请输入孩子的姓名">
            <select name="ages" v-model="auditions.age" id="">
              <option value="">请选择孩子的年龄</option>
              <option :value="item" v-for="item in 20" :key="item">{{item}}</option>
            </select>
            <input type="text" maxlength="11" v-model="auditions.mobile" placeholder="请输入手机号">
            <div class="code">
              <input type="text" v-model="auditions.captcha" placeholder="请输入验证码">
              <div class="btn" @click="!timeFlag && getSmscode()">
                <span v-show="!timeFlag">{{btnText}}</span>
                <span v-show="timeFlag">{{btnText}}s</span>
              </div>
            </div>
            <div class="submit" @click=" receiveFlag && receive()">免费领取</div>
          </div>
        </div>
      </div>
      <!-- 学术主张 -->
      <div class="way-home-initiative">
          <div class="row align-items-center">
              <div class="col-xl-12 col-12 con-title">
                  <p class="con-title-top">学术主张</p>
                  <p class="con-title-bot">The Big R Initiative</p>
              </div>
              <div class="col-xl-5">
                  <img src="https://static.cleanlive.cn/site/img/learning-left.png" alt="">
              </div>
              <div class="col-xl-5 initiative-right">
                  <img class="pc-learning" src="https://static.cleanlive.cn/site/img/learning-text.png" alt="">
                  <img class="yd-learning" src="https://static.cleanlive.cn/site/img/yd-learning-text.png" alt="">
              </div>
          </div>
      </div>
      <!-- 教育理念 -->
      <div class="way-home-beliefs">
          <div class="row justify-content-center">
              <div class="col-xl-12 col-12 con-title">
                  <p class="con-title-top">教育理念</p>
                  <p class="con-title-bot">Our Beliefs</p>
              </div>
              <div class="col-xl-10 beliefs-con">
                  <ul class="beliefs-con-list">
                      <li>
                          <img src="https://static.cleanlive.cn/site/img/education-list-1.png" alt="">
                          <div class="list-title">
                              <p class="list-title-top">遵循国际标准</p>
                              <p class="list-title-bot">有标准、有体系</p>
                          </div>
                          <div class="list-con">
                            开展系统学习，
                            <br/>保证孩子的英语学习走对方向、
                            <br/>走对路！
                          </div>
                      </li>
                      <li>
                          <img src="https://static.cleanlive.cn/site/img/education-list-2.png" alt="">
                          <div class="list-title">
                              <p class="list-title-top">尊重学习规律</p>
                              <p class="list-title-bot">有兴趣、有情感</p>
                          </div>
                          <div class="list-con">
                              尊重学习者天性，<br/>将学习的乐趣和成就感还给孩子！
                          </div>
                      </li>
                      <li>
                          <img src="https://static.cleanlive.cn/site/img/education-list-3.png" alt="">
                          <div class="list-title">
                              <p class="list-title-top">塑造软硬实力</p>
                              <p class="list-title-bot">重语用、重素养</p>
                          </div>
                          <div class="list-con">
                            为学习者提供真实情景下
                            <br/>有心流的内容和设计，
                            <br/>让英语学习更有效、更优效！
                          </div>
                      </li>
                      <li>
                          <img src="https://static.cleanlive.cn/site/img/education-list-4.png" alt="">
                          <div class="list-title">
                              <p class="list-title-top">提供真实情景</p>
                              <p class="list-title-bot">重情境、重习得</p>
                          </div>
                          <div class="list-con">
                            关注英语学习者的语用能力
                            <br/>和综合素养，
                            <br/>打造孩子参与国际竞争的软硬实力！
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
      </div>
      <!-- 成长路径 -->
      <div class="way-home-map">
        <div class="row justify-content-center align-items-center">
          <div class="col-xl-12 col-12 con-title">
              <p class="con-title-top">成长路径</p>
              <p class="con-title-bot">Learning Journey</p>
          </div>
          <div class="col-xl-10 col-11 map-img">
            <img src="https://static.cleanlive.cn/site/img/home-growup.png" alt="">
          </div>
        </div>
      </div>
      <!-- 遴选外教 -->
      <div class="way-home-educators" id="home_educators">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-12 con-title">
              <p class="con-title-top">严格遴选外教</p>
              <p class="con-title-bot">The Educators</p>
          </div>
          <div class="col-xl-12 col-11 educators-title">
            持有国际从业资格证&emsp;拥有先进教育精髓和理念&emsp;具有丰富的授课经验
          </div>
          <div class="col-xl-10 col-11 educators-con">
            <ul class="educators-con-list">
              <li>
                <img src="https://static.cleanlive.cn/site/img/percentage-img2.png" alt="">
                <p class="educators-con-list-tit">学历认证</p>
                <p class="educators-con-list-text">
                  高资历外教，<br/>100%本科及以上学历
                </p>
              </li>
              <li>
                <img src="https://static.cleanlive.cn/site/img/percentage-img2.png" alt="">
                <p class="educators-con-list-tit">安全认证</p>
                <p class="educators-con-list-text">
                  谨慎严选，100%背景调查，<br/>确保每位教师的信用度和安全性
                </p>
              </li>
              <li>
                <img src="https://static.cleanlive.cn/site/img/percentage-img1.png" alt="">
                <p class="educators-con-list-tit">录取率</p>
                <p class="educators-con-list-text">
                  低于6%录取率，<br/>层层筛选，优中选优
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 我们的课程 -->
      <div class="way-home-course" id="home_course">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-12 con-title">
              <p class="con-title-top">我们的课程</p>
              <p class="con-title-bot">Our Courses</p>
          </div>
        </div>
        <div class="row justify-content-between align-items-end couse-com-img" v-show="courseDom">
          <transition name="courselate" enter-active-class="animated fadeInLeftBig" leave-active-class="animated fadeInLeftBig">
            <div class="col-xl-6 col-12" v-show="courseDom">
              <img src="https://static.cleanlive.cn/site/img/home-course-left.png" alt="">
            </div>
          </transition>
          <transition name="courselate" enter-active-class="animated fadeInRightBig" leave-active-class="animated fadeInRightBig">
            <div class="col-xl-6 col-12" v-show="courseDom">
              <img src="https://static.cleanlive.cn/site/img/home-course-right.png" alt="">
            </div>
          </transition>
        </div>
      </div>
      <!-- 我们的承诺 -->
      <div class="way-home-commit" id="home_commit">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-12 con-title">
            <p class="con-title-top">我们的承诺</p>
            <p class="con-title-bot">Our Beliefs</p>
          </div>
          <div class="col-xl-10 col-11 commit-con">
            <ul class="commit-con-list">
              <transition name="commitzoom" enter-active-class="animated zoomIn" leave-active-class="animated zoomIn" @enter="commitEnter(0)">
                <li v-show="commitDom">
                  <img src="https://static.cleanlive.cn/site/img/commit-img1.png" alt="">
                  <p class="commit-list-tit">权益承诺</p>
                  <p class="commit-list-text">100%珍视每一个用户家庭，<br/>签订公平、规范的服务协议，<br/>明确服务职责，<br/>保护每一位学员利益。</p>
                </li>
              </transition>
              <transition name="commitzoom" enter-active-class="animated zoomIn" leave-active-class="animated zoomIn" @enter="commitEnter(1)">
                <li v-show="commitDom2">
                  <img src="https://static.cleanlive.cn/site/img/commit-img2.png" alt="">
                  <p class="commit-list-tit">服务承诺</p>
                  <p class="commit-list-text">100%英语专业辅导员跟踪服务，<br/>为学员定制个性化学习方案，<br/>协助师生沟通反馈，<br/>督促辅导学习成长。</p>
                </li>
              </transition>
              <transition name="commitzoom" enter-active-class="animated zoomIn" leave-active-class="animated zoomIn">
                <li v-show="commitDom3">
                  <img src="https://static.cleanlive.cn/site/img/commit-img3.png" alt="">
                  <p class="commit-list-tit">师资承诺</p>
                  <p class="commit-list-text">100%精选欧美一线教师，<br/>录取率低于6%，<br/>严格把关教学质量。</p>
                </li>
              </transition>
            </ul>
          </div>
        </div>
      </div>
      <!-- 学术合作 -->
      <div class="way-home-coop">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-12 con-title">
            <p class="con-title-top">学术合作</p>
            <p class="con-title-bot">Academic Cooperation</p>
          </div>
          <div class="col-xl-10 col-11 coop-con">
            <ul class="coop-con-list">
              <li>
                <img src="https://static.cleanlive.cn/site/img/cooperation-Research.png" alt="">
                <p>外语教学与研究出版社</p>
              </li>
              <li>
                <img src="https://static.cleanlive.cn/site/img/cooperation-BFS.png" alt="">
                <p>北京外国语大学</p>
              </li>
              <li>
                <img src="https://static.cleanlive.cn/site/img/cooperation-plus.png" alt="">
                <p>北外壹佳英语</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="way-friends-chain">
        <div class="row">
          <div class="col-xl-10 col-12 friends-chain-con">
            <div class="friends-chain-title">友情链接 ：</div>
            <ul class="friends-chain-list">
              <li><a href="http://www.fltrp.com/" target="_blank">外研社</a></li>
              <li><a href="http://www.beiwaiguoji.com/" target="_blank">北外国际</a></li>
              <li><a href="https://www.intergreat.com/" target="_blank">英萃教育</a></li>
              <li><a href="http://www.beiwaiqingshao.com/" target="_blank">北外壹佳英语</a></li>
              <li><a href="http://www.bfsu.edu.cn/" target="_blank">北京外国语大学</a></li>
            </ul>
          </div>
        </div>
      </div>
      <auditions @setDiaLog="setDiaLog" step="2" v-if="auditionsShow"/>
      <div class="alert alert-warning" role="alert" v-show="alertShow">
        <strong>{{alertText}}</strong>
      </div>
    </div>
</template>
<script>
import axios from 'axios';
import qs from 'qs';
import auditions from '../components/auditions.vue';

export default {
  name: 'home',
  components: {
    auditions,
  },
  data() {
    return {
      fxiedFlag: true,
      receiveFlag: true,
      auditionsShow: false,
      dialogFlag: true,
      alertText: '',
      timeFlag: false,
      alertShow: false,
      courseDom: false,
      commitDom: false,
      commitDom2: false,
      commitDom3: false,
      btnText: '获取验证码',
      timer: null,
      auditions: {
        name: '',
        age: '',
        mobile: '',
        captcha: '',
        source: 1,
      },
    };
  },
  mounted() {
    window.addEventListener('scroll', this.watchScroll);
  },
  methods: {
    watchScroll() {
      if (this.$route.name !== 'home') return;
      const scrollTop = window.scrollY;
      const homeCourse = document.querySelector('#home_course');
      const homeCommit = document.querySelector('#home_commit');
      const homeEducators = document.querySelector('#home_educators');
      const courseTop = homeCourse.offsetTop;
      const commitTop = homeCommit.offsetTop;
      const educatorsTop = homeEducators.offsetTop;
      const educatorsHei = homeEducators.offsetHeight;
      if (scrollTop >= courseTop - 500) {
        this.courseDom = true;
      }
      if (scrollTop >= commitTop - 500) {
        this.commitDom = true;
      }
      if (scrollTop <= educatorsTop + educatorsHei) {
        this.fxiedFlag = true;
      } else {
        this.fxiedFlag = false;
      }
    },
    commitEnter(type) {
      if (!type) {
        this.commitDom2 = true;
      } else {
        this.commitDom3 = true;
      }
    },
    getSmscode() {
      const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
      if (!reg.test(this.auditions.mobile)) {
        const _this = this;
        this.alertText = '请输入正确手机号';
        this.alertShow = true;
        setTimeout(() => {
          _this.alertShow = false;
        }, 2000);
        return;
      }
      const params = {
        mobile: this.auditions.mobile,
        type: 4,
      };
      axios.post(`${process.env.API_HOST}/api/applystudys/smscode`, qs.stringify(params)).then((res) => {
        if (res.data.code === 200) {
          this.alertText = '验证码发送成功,请注意查收';
          this.timeFlag = true;
          this.btnText = 60;
          const _this = this;
          this.timer = setInterval(() => {
            if (this.btnText === 0) {
              clearInterval(_this.timer);
              _this.timeFlag = false;
              _this.btnText = '获取验证码';
              return;
            }
            _this.btnText -= 1;
          }, 1000);
        } else {
          this.alertText = res.data.tip;
        }
        this.alertShow = true;
        setTimeout(() => {
          this.alertShow = false;
          this.alertText = '';
        }, 2000);
      }).catch((err) => {
        console.lgo(err);
      });
    },
    receive() {
      if (this.auditions.name === '' || this.auditions.age === '' || this.auditions.mobile === '' || this.auditions.captcha === '') {
        this.alertText = '请填写相关信息';
        this.alertShow = true;
        setTimeout(() => {
          this.alertShow = false;
        }, 2000);
        return;
      }
      axios.post(`${process.env.API_HOST}/api/applystudys/create`, qs.stringify(this.auditions)).then((res) => {
        this.receiveFlag = false;
        setTimeout(() => {
          this.receiveFlag = true;
        }, 3000);
        if (res.data.code === 200) {
          this.auditionsShow = true;
          clearInterval(this.timer);
          this.btnText = '获取验证码';
          this.timeFlag = false;
          this.auditions = {
            name: '',
            age: '',
            mobile: '',
            captcha: '',
            source: 1,
          };
        } else {
          this.alertText = res.data.tip;
          this.alertShow = true;
          setTimeout(() => {
            this.alertShow = false;
          }, 2000);
        }
      }).catch((err) => {
        console.lgo(err);
      });
    },
    setDiaLog() {
      this.auditionsShow = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../assets/css/reset.less";
.way-home-main {
  .way-home-banner {
    position: relative;
    .carousel-indicators {
      bottom: 30px;
      li {
        margin: 0 5px;
      }
    }
    .small {
      display: none;
    }
    .login {
      position: absolute;
      height: 600px;
      width: 430px;
      background: #ffffff;
      top: 50%;
      right: 5%;
      border-radius: 8px;
      padding-top: 5%;
      transform: translateY(-50%);
      .tit {
        font-size: 28px;
        margin: 0 0 5%;
        span {
          color: #FE9D15;
        }
      }
      input, select {
        padding: 13px 15px;
        width: 340px;
        height: 48px;
        outline: none;
        margin: 15px 0 0;
        border: 1px solid #C3C3C3;
        border-radius: 8px;
      }
      .code {
        display: flex;
        width: 340px;
        margin: 15px auto 0;
        justify-content: space-between;
        input {
          width: 220px;
          height: 48px;
          margin: 0;
        }
        .btn {
          width: 112px;
          height: 48px;
          border: none;
          line-height: 48px;
          padding: 0;
          color: #fff;
          background: linear-gradient(90deg, #FFB83F, #FE9000);
        }
      }
      .submit {
        width: 340px;
        height: 48px;
        border: none;
        line-height: 48px;
        padding: 0;
        color: #fff;
        cursor: pointer;
        border-radius: 8px;
        margin: 50px auto 0;
        background: linear-gradient(90deg, #FFB83F, #FE9000);
      }
    }
  }
  .home-fixed-back1 {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    background: url("https://static.cleanlive.cn/site/img/fixed-back-1.png") no-repeat;
    background-size: 100% 100%;
  }
  .home-fixed-back2 {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    background: url("https://static.cleanlive.cn/site/img/fixed-back-2.png") no-repeat;
    background-size: 100%;
  }
  // 学术主张
  .way-home-initiative {
    padding: 3rem 0;
    background: #fff;
    .con-title-top {
      color: rgba(255, 126, 0, 1);
    }
    .con-title-bot {
      color: rgba(254, 233, 211, 1);
    }
    .initiative-right {
      margin-left: 86px;
      .yd-learning {
        display: none;
      }
    }
  }
  // 教育理念
  .way-home-beliefs {
    min-height: 630px;
    padding-top: 3rem;
    background: url("https://static.cleanlive.cn/site/img/education-back.png") no-repeat top left;
    .con-title-top {
      color: rgba(255, 255, 255, 1);
    }
    .con-title-bot {
      color: rgba(255, 255, 255, 0.3);
    }
    .beliefs-con {
      max-width: 1200px;
      .beliefs-con-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          width: 270px;
          height: 320px;
          position: relative;
          background: #fff;
          border-radius: 8px;
          padding: 2rem 1rem;
          text-align: center;
          box-sizing: border-box;
          margin-bottom: 2rem;
          transition: transform 1s;
          .list-title {
            margin-top: 2rem;
            margin-bottom: 2rem;
            .list-title-top {
              font-size: 20px;
              font-family: PingFang-SC-Medium;
              color: rgba(97, 97, 97, 1);
            }
            .list-title-bot {
              font-size: 16px;
              font-family: PingFang-SC-Medium;
              color: rgba(255, 151, 0, 1);
            }
          }
          .list-con {
            display: none;
            font-size: 14px;
            font-family: PingFang-SC-Medium;
            color: rgba(107, 107, 107, 1);
          }
          &:hover {
            top: -40px;
            height: 400px;
            z-index: 1;
            transform: scale(1.2);
            .list-title-top {
              color: rgba(44, 91, 252, 1);
            }
            .list-con {
              display: block;
            }
          }
        }
      }
    }
  }
  // 成长路径
  .way-home-map {
    padding: 3rem 0;
    background: #fff;
    .con-title-top {
      color: rgba(255, 126, 0, 1);
    }
    .con-title-bot {
      color: rgba(254, 233, 211, 1);
    }
    .map-img {
      max-width: 1200px;
    }
  }
  // 遴选外教
  .way-home-educators {
    padding: 3rem 0;
    background: rgba(0, 0, 0, 0.3);
    .con-title-top {
      color: rgba(255, 255, 255, 1);
    }
    .con-title-bot {
      color: rgba(255, 255, 255, 0.3);
    }
    .educators-title {
      font-size: 20px;
      color: #fff;
      font-family: PingFang-SC-Medium;
    }
    .educators-con {
      max-width: 1200px;
      .educators-con-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          width: 306px;
          text-align: center;
          padding-top: 4rem;
          .educators-con-list-tit {
            font-size: 26px;
            font-family: RTWSYueGoG0v1-Regular;
            color: rgba(255, 188, 54, 1);
            padding-top: 3rem;
            padding-bottom: 2rem;
          }
          .educators-con-list-text {
            font-size: 18px;
            font-size: PingFang-SC-Medium;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  // 我们的课程
  .way-home-course {
    background: #fff;
    min-height: 700px;
    padding: 3rem 0;
    .con-title-top {
      color: rgba(255, 126, 0, 1);
    }
    .con-title-bot {
      color: rgba(254, 233, 211, 1);
    }
    .couse-com-img {
      max-width: 1200px;
      margin: 0 auto;
      img {
        width: 92%;
      }
    }
  }
  // 我们的承诺
  .way-home-commit {
    padding: 3rem 0;
    background: url("https://static.cleanlive.cn/site/img/home-commit-bakc.png") no-repeat left top;
    min-height: 740px;
    .con-title-top {
      color: rgba(255, 255, 255, 1);
    }
    .con-title-bot {
      color: rgba(255, 255, 255, 0.3);
    }
    .commit-con {
      max-width: 1200px;
      .commit-con-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        li {
          width: 362px;
          margin: 2rem 1rem 0 0;
          padding: 2rem 0;
          background: #fff;
          border-radius: 8px;
          text-align: center;
          img {
            width: 230px;
          }
          .commit-list-tit {
            padding-top: 2rem;
            padding-bottom: 3rem;
            font-size: 30px;
            font-family: PingFang-SC-Medium;
            color: rgba(45, 101, 255, 1);
          }
          .commit-list-text {
            width: 82%;
            margin: 0 auto;
            font-size: 18px;
            font-family: PingFang-SC-Medium;
            color: rgba(107, 107, 107, 1);
          }
        }
        & li:nth-child(3) {
          margin: 2rem 0 0 0;
        }
      }
    }
  }
  // 学术合作
  .way-home-coop {
    padding: 3rem 0;
    background: rgba(0, 0, 0, 0.3);
    .con-title-top {
      color: rgba(255, 255, 255, 1);
    }
    .con-title-bot {
      color: rgba(255, 255, 255, 0.3);
    }
    .coop-con {
      max-width: 1200px;
      .coop-con-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
          width: 306px;
          padding-top: 3rem;
          p {
            padding: 3rem 0;
            font-size: 26px;
            font-family: PingFang-SC-Medium;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  // 友情链接
  .way-friends-chain {
    background: #909090;
    .friends-chain-con {
      max-width: 1200px;
      margin: 0 auto;
      padding: 1rem 0;
      display: flex;
      align-items: flex-start;
      .friends-chain-title {
        width: 100px;
        padding: .1rem 0;
        font-size: 14px;
        color: #fff;
      }
      .friends-chain-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        li {
          margin-right: 1rem;
          color: #fff;
          a {
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1919px) {
  .way-home-main .way-home-commit .commit-con .commit-con-list li {
    margin: 2rem 3.4rem 0 0;
  }
}
@media screen and (max-width: 1450px) {
  .way-home-main {
    .way-home-banner {
      position: relative;
      .login {
        position: absolute;
        height: 480px;
        width: 350px;
        background: #ffffff;
        top: 50%;
        right: 5%;
        border-radius: 8px;
        padding-top: 40px;
        transform: translateY(-50%);
        font-size: 14px;
        .tit {
          font-size: 24px;
          margin: 0 0 10px;
          span {
            color: #FE9D15;
          }
        }
        input, select {
          padding: 13px 15px;
          width: 250px;
          height: 48px;
          outline: none;
          margin: 15px 0 0;
          border: 1px solid #C3C3C3;
          border-radius: 8px;
          &::-webkit-input-placeholder {
            color: #B9B9B9;
          }
        }
        .code {
          display: flex;
          width: 250px;
          margin: 15px auto 0;
          justify-content: space-between;
          input {
            width: 160px;
            height: 48px;
            margin: 0;
          }
          .btn {
            width: 80px;
            height: 48px;
            border: none;
            line-height: 48px;
            padding: 0;
            font-size: 12px;
            color: #fff;
            background: linear-gradient(90deg, #FFB83F, #FE9000);
          }
        }
        .submit {
          width: 290px;
          height: 48px;
          border: none;
          line-height: 48px;
          padding: 0;
          color: #fff;
          cursor: pointer;
          border-radius: 8px;
          margin: 40px auto 0;
          background: linear-gradient(90deg, #FFB83F, #FE9000);
        }
      }
    }
  }
}
@media screen and (max-width: 414px) {
  .way-home-main {
    .way-home-banner {
      .big {
        display: none;
      }
      .small {
        display: block;
      }
      position: relative;
      .login {
        display: none;
        position: absolute;
        height: 480px;
        width: 350px;
        background: #ffffff;
        top: 50%;
        right: 5%;
        border-radius: 8px;
        padding-top: 40px;
        transform: translateY(-50%);
        font-size: 14px;
        .tit {
          font-size: 24px;
          margin: 0 0 10px;
          span {
            color: #FE9D15;
          }
        }
        input, select {
          padding: 13px 15px;
          width: 250px;
          height: 48px;
          outline: none;
          margin: 15px 0 0;
          border: 1px solid #C3C3C3;
          border-radius: 8px;
        }
        .code {
          display: flex;
          width: 250px;
          margin: 15px auto 0;
          justify-content: space-between;
          input {
            width: 160px;
            height: 48px;
            margin: 0;
          }
          .btn {
            width: 80px;
            height: 48px;
            border: none;
            line-height: 48px;
            padding: 0;
            font-size: 12px;
            color: #fff;
            background: linear-gradient(90deg, #FFB83F, #FE9000);
          }
        }
        .submit {
          width: 290px;
          height: 48px;
          border: none;
          line-height: 48px;
          padding: 0;
          color: #fff;
          cursor: pointer;
          border-radius: 8px;
          margin: 40px auto 0;
          background: linear-gradient(90deg, #FFB83F, #FE9000);
        }
      }
    }
    .home-fixed-back1 {
      background: url("https://static.cleanlive.cn/site/img/fixed-yd-back1.png") no-repeat;
      background-size: 100% 100%;
    }
    .home-fixed-back2 {
      background: url("https://static.cleanlive.cn/site/img/fixed-yd-back2.png") no-repeat;
      background-size: 100% 100%;
    }
    // 学术主张
    .way-home-initiative {
      .initiative-right {
        margin-top: 30px;
        margin-left: 0;
        .pc-learning {
          display: none;
        }
        .yd-learning {
          display: block;
        }
      }
    }
    // 教育理念
    .way-home-beliefs {
      padding: 3rem 0;
      background: linear-gradient(
        90deg,
        rgba(255, 184, 63, 1),
        rgba(254, 144, 0, 1)
      );
      .beliefs-con {
        .beliefs-con-list {
          justify-content: center;
          li {
            width: 90%;
            height: 480px;
            .list-con {
              display: block;
              font-size: 16px;
            }
          }
        }
      }
    }
    // 遴选外教
    .way-home-educators .educators-con .educators-con-list {
      justify-content: center;
    }
    // 我们的承诺
    .way-home-commit {
      background: linear-gradient(
        90deg,
        rgba(255, 184, 63, 1),
        rgba(254, 144, 0, 1)
      );
      .commit-con .commit-con-list {
        justify-content: center;
        li {
          width: 94%;
        }
      }
    }
    // 学术合作
    .way-home-coop .coop-con .coop-con-list {
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue